<template>
  <div>
    <div class="right-title">
      <span>{{name}}报名列表</span>
      <el-button plain class="go-back" @click="goBack">返回</el-button>
    </div>
    <div class="content-box">
      <div class="search-box">
        <el-button type="primary" @click="type=0">全部报名表</el-button>
        <el-button type="danger" @click="type=1" style="margin-right: 10px;">双选会报名表</el-button>
        <el-input
          class="search"
          type="text"
          prepend="iconbianji1"
          placeholder="请输入关键字"
          v-model="search"
        >
        </el-input>
        <el-button @click="keyWord" type="primary" style="margin-left: 10px;">搜索</el-button>
      </div>
      <div class="tab-box">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%;height: 100%"
          :header-cell-style="{background: '#f2f3f5',
    color: '#000;'}"
          @selection-change="handleSelectionChange"
          >
          <el-table-column
            fixed
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column
            prop="user_id"
            label="ID"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="user_name"
            label="注册手机号"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="organization_name"
            label="机构名称"
            align="center"
          >
            <template slot-scope="scope">
              <span class="hals-color hal-cursor" @click="toDetail(scope.row.user_id)">{{scope.row.organization_name}}</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="wechat_name"
            label="微信号"
            align="center"
          >
          </el-table-column>

          <el-table-column

            label="查看详情"
            align="center"
          >
            <template slot-scope="scope">
              <span class="hal-cursor hals-color" @click="toDetail(scope.row.user_id)">查看详情</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="user_name"
            label="审核状态"
            align="center"
          >
            <template slot-scope="scope">
              <span class="hal-cursor" v-if="scope.row.certification ===0">基础信息未填写</span>
              <span class="hal-cursor" v-if="scope.row.certification ===1">基础信息已填写待机构审核</span>
              <span class="hal-cursor" v-if="scope.row.certification ===2">正常</span>
              <span class="hal-cursor" v-if="scope.row.certification ===3">基础信息被驳回</span>
            </template>
          </el-table-column>
          <el-table-column
            label="双选会状态"
            align="center"
          >
            <template slot-scope="scope">
              <div class="swBox" style="position: relative;">
                <el-switch
                  v-model="scope.row.is_show"
                  active-color="#bababa"
                  inactive-color="#00a2ea"
                >
                </el-switch>
                <div class="swShade" @click="shuangxuanhui(scope.row.is_show,scope.row.user_id)"
                     style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;"></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column

            label="全国性组织"
            align="center"
          >
            <template slot-scope="scope">
              <div class="swBox" style="position: relative;">
                <el-switch
                  v-model="scope.row.is_nationwide"
                  active-color="#bababa"
                  inactive-color="#00a2ea"
                >
                </el-switch>
                <div class="swShade" @click="nationwide(scope.row.is_nationwide,scope.row.user_id)"
                     style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;"></div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="page-box">
          <div>
            <el-button type="primary" @click="addChiose(1)">加入双选会</el-button>
            <el-button type="danger" @click="addChiose(0)">取消加入双选会</el-button>
            共计{{page.pageTotal}}条

          </div>
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page.pageNum"
            :page-size="page.pageSize"
            layout="prev, pager, next, jumper"
            :total="page.pageTotal">
          </el-pagination>
        </div>
      </div>
    </div>
    <footerBox class="footer"/>
  </div>
</template>

<script>
  import footerBox from '../components/rightBottom'

  export default {
    name: "meetDetail",
    data() {
      return {
        name:'',
        search: '',  // 搜索
        tableData: [],
        type:0,  // 0 全部  1 双选会
        multipleSelection: [], //  选中的
        page: {
          pageNum: 1,
          pageSize: 10,
          pageTotal: 1
        },
      }
    },
    computed: {
      user() {
        return this.$store.state.user
      }
    },
    created() {
      this.name = this.$route.query.name
      this.$emit('setType', 1)
      this.baoming()
    },
    methods: {
      //  批量加入
      addChiose(num){
        if(this.multipleSelection === 0) return
        let arr = []
        this.multipleSelection.map(item=>{
          arr.push(item.user_id)
        })
        this.$api.apiContent.setSXHOrgShowOrHidden2({
          sxhOrgId: arr.join(','),
          setType:num,
          sxhId: this.$route.query.id,
          adminId: this.user.id
        }).then(res => {
          this.$message({
            type: 'success',
            message: res.info
          });
          this.baoming()
        }).catch(res => {
          this.$message.error(res.info);
        })
      },


      //机构详情
      toDetail(id) {
        this.$router.push({
          path: '/home/jgAdmin/jgDetail/' + id
        })
      },
      // 机构列表
      baoming() {
        const loading = this.$loading({
          target: this.$refs.listBox,
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)'
        });
        if (this.$route.query.pageNum) {
          this.page.pageNum = Number(this.$route.query.pageNum)
        } else {
          this.page.pageNum = 1
        }
        if (this.$route.query.key) {
          this.search = this.$route.query.key
        } else {
          this.search = ''
        }
        if (this.$route.query.type) {
          this.type = Number(this.$route.query.type)
        } else {
          this.type = 0
        }
        this.$api.apiContent.showSHXApplyFormList2({
          adminId: this.user.id,
          sxhId: this.$route.query.id,
          searchName: this.search,
          showType: this.type,
          page: this.page.pageNum,
          pageSize: this.page.pageSize,
        }).then(res => {
          loading.close();
          this.page.pageNum = res.now_page
          this.page.pageTotal = res.total_number
          this.tableData = res.data
          this.tableData.map(item => {
            item.is_show = item.is_show === 0 ? (true) : (false)      //  双选会
            item.is_nationwide = item.is_nationwide === 0 ? (true) : (false)  //  全国
          })
        }).catch(() => {
          loading.close();
          this.tableData = []
          this.page.pageTotal = 0
        })

      },
      //  列表选中存入数据
      handleSelectionChange(val) {
        this.multipleSelection = val;
        console.log(this.multipleSelection)
      },
      handleSizeChange(num) {        //  点击分页
        this.page.pageNum = num
      },
      handleCurrentChange(num) {     //  选择页数
        this.page.pageNum = num
      },
      keyWord() {     //  搜索
        if (this.page.pageNum === 1) {
          this.setPath()
        } else {
          this.page.pageNum = 1
        }
      },
      //  修改路径
      setPath() {
        this.$router.push({
          path: '/home/meetAdmin/meetDetail2',
          query: {
            pageNum: this.page.pageNum,
            key: this.search,
            type: this.type,
            id:this.$route.query.id,
            name:this.$route.query.name
          }
        })
      },
      //  双选会开关
      shuangxuanhui(show,id){
        let state = ""
        this.tableData.map(item => {
          if (item.user_id === id) {
            state = item.show
          }
        })
        let messg = ""
        if (!state) {
          messg = "此操作将设置机构加入双选会, 是否继续?"
        } else {
          messg = "此操作将取消机构加入双选会, 是否继续?"
        }
        this.$confirm(messg, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.apiContent.setSXHOrgShowOrHidden2({
            sxhOrgId: id,
            setType:show?1:0,
            sxhId: this.$route.query.id,
            adminId: this.user.id
          }).then(res => {
            this.$message({
              type: 'success',
              message: res.info
            });
            this.baoming()
          }).catch(res => {
            this.$message.error(res.info);
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      //  全国
      nationwide(show,id){
        let state = ""
        this.tableData.map(item => {
          if (item.user_id === id) {
            state = item.show
          }
        })
        let messg = ""
        if (!state) {
          messg = "此操作将设置机构为全国性组织, 是否继续?"
        } else {
          messg = "此操作将取消机构为全国性组织, 是否继续?"
        }
        this.$confirm(messg, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.apiContent.sxhAddress2({
            userId: id,
            setType:show?1:0,
            sxhId: this.$route.query.id,
            adminId: this.user.id
          }).then(res => {
            this.$message({
              type: 'success',
              message: res.info
            });
            this.baoming()
          }).catch(res => {
            this.$message.error(res.info);
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },





      goBack() {     //  返回上一页
        this.$tools.goBack()
      },
    },
    watch: {
      'page.pageNum'() {
        this.setPath()
      },
      type(){
        this.page.pageNum =1
        this.setPath()
      },
      $route() {
        this.baoming()
      }
    },
    components: {
      footerBox
    }
  }
</script>

<style scoped lang="scss">
  .search-box {
    position: absolute;
    top: 10px;
    left: 10px;
    right: 10px;
    z-index: 1;
    display: flex;
    justify-content: flex-end;

    .search {
      width: 220px;
    }
  }

  .tab-box {
    position: relative;
    /*top: 64px;*/
    /*left: 10px;*/
    /*right: 10px;*/
    /*bottom: 60px;*/
    min-height: 100%;
    padding-top: 50px;
    padding-bottom: 60px;
    background: #fff;


    .page-box {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 60px;
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

</style>